<template>
    <form-wrapper :title="option.title"
                :description="option.description"
                @submit="submitFile()"
                @previous="previous()"
                :isFirst="isFirst"
                :isLast="isLast">
      <label for="file-select" class="mr-sm-2" :class="{ 'invalid-label': $v.file.$error }">File</label>
      <b-form-file id="file-select" v-model="file"></b-form-file>
      <span class="span-feedback invalid-feedback" v-if="$v.file.$error">
        You must select a file.
      </span>
    </form-wrapper>
</template>

<script>
import { mapActions, mapState } from "vuex";
import placementsApi from "../../../api/placements/opportunities";
import { required } from "vuelidate/lib/validators";
import formWrapper from "./form-wrapper";

export default {
  data() {
    return {
      file: null
    };
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    studentOpportunityAdditionalMaterialId: {
      type: Number,
      required: true
    },
    studentOpportunityId: {
      type: Number,
      required: false
    },
    callback: {
      type: String,
      required: false
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    "form-wrapper": formWrapper
  },

  validations: {
    file: {
      required
    }
  },

  computed: {
    ...mapState({
      userId: state => state.auth.user.userId
    })
  },
  methods: {
    ...mapActions("placements", ["postFile"]),
    handleInput: function() {
      this.returnItem();
    },
    returnItem: function() {
      this.$emit("input", this.form);
    },
    previous: function() {
      this.$emit("previous");
    },
    submitFile: function() {
      var that = this;
      this.$v.$touch();

      if (!this.$v.$invalid) {
        var formData = {};
        formData.studentOpportunityAdditionalMaterialId = this.studentOpportunityAdditionalMaterialId;
        var fileList = [];
        fileList.push(this.file);
        this.postFile({ formData: formData, fileList: fileList })
          .then(function() {
            // refresh data
            that.$v.$reset();
            that.file = null;
            that.$emit("refresh");
            that.$emit("submitted");

            if (that.callback) {
              placementsApi.postCallbackRequest(
                that.callback,
                that.studentOpportunity.studentOpportunityId
              );
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
.invalid-label {
  color: #dc3545;
}
</style>
